export default __webpack_public_path__ + "static/media/ownerRezLogo.1913d3e5.png";